import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { useAuthStore } from '../store/authStore';
import { useI18n } from '../i18n/I18nProvider';

/**
 * Dashboard shell. Beyond the visual chrome, this also enforces the
 * onboarding gate: if the user is authenticated but hasn't finished the
 * "social links" step, they're bounced to /onboarding/social-links.
 *
 * The gate relies on `user.has_social_links`, which the backend sets in
 * the login/register response and the onboarding page flips locally on
 * save/skip.
 */
export default function DashboardLayout() {
  const user = useAuthStore((s) => s.user);
  const { isArabic } = useI18n();

  // User cookie is hydrated before this renders (see App.jsx). If for any
  // reason the flag is missing (e.g. upgrading from an older cached user
  // object), treat it as "completed" to avoid trapping existing users.
  const hasLinks =
    user && (user.has_social_links === undefined || user.has_social_links === true);

  if (user && !hasLinks) {
    return <Navigate to="/onboarding/social-links" replace />;
  }

  return (
    <div className="relative flex min-h-screen">
      <Sidebar />
      <div className={`flex min-w-0 flex-1 flex-col ${isArabic ? 'lg:pr-64' : 'lg:pl-64'}`}>
        <Navbar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 animate-fade-in">
          <div className="mx-auto w-full max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
